import { normalizeSeverity } from './severity'

/**
 * severityDistribution — per-severity counts across a scanned entity list,
 * for the run-level distribution bar. Never-probed entities (and those with
 * no recognizable severity) form their own grey segment: a run that skipped
 * 10% of its scope must not read as 100% healthy (audit F6 principle).
 *
 * @param {Array} entities - entity summaries (must cover the scanned scope)
 * @returns {{ severe: number, moderate: number, mild: number, healthy: number,
 *   unprobed: number, total: number }}
 */
export const severityDistribution = (entities = []) => {
    const counts = { severe: 0, moderate: 0, mild: 0, healthy: 0, unprobed: 0, total: 0 }
    for (const entity of entities) {
        counts.total += 1
        if (entity?.unprobed === true) {
            counts.unprobed += 1
            continue
        }
        const key = normalizeSeverity(entity?.severity)
        if (key === 'unknown') {
            counts.unprobed += 1
        } else {
            counts[key] += 1
        }
    }
    return counts
}
